export function calculateLuhnCheckDigit(code){
  let length = code.length;
  let parity = length % 2;
  let luhnSum = 0;

  for (let i = length-1; i >= 0; i--) {
    let luhnDigit = parseInt(code.charAt(i), 10);

    if (i % 2 === parity) {
      luhnDigit *= 2;
    };

    if (luhnDigit > 9) {
      luhnDigit -= 9;
    }
    luhnSum += luhnDigit;
  }

  let luhnCheckDigit = luhnSum % 10;
  if (luhnCheckDigit === 0)
    return 0;
  else
    return 10 - luhnCheckDigit;

}

export function validate(codeWithCheckDigit) {
  return calculateLuhnCheckDigit(codeWithCheckDigit) === 0;
}

export default{
  validate
}
